export function formatPercent(float) {
  if (isNaN(float)) {
    return '';
  }
  return `${Number(float * 100).toFixed(3)}%`;
}

export function formatInt(n, minimumFractionDigits = 0, maximumFractionDigits = 0) {
  if (n === '' || n === undefined || n === null || Number.isNaN(n)) {
    return '';
  }
  return Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits,
    maximumFractionDigits
  }).format(n);
}

export function formatMoney(n, digits = 0) {
  if (isNaN(n)) {
    return n;
  }

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: digits,
    maximumFractionDigits: digits
  }).format(n);
}

export function formatPercentInput(ratio) {
  return parseFloat((ratio * 100).toFixed(2));
}

// TODO: import a library instead
export function nFormatter(num, digits = 0) {
  if (num === undefined || num === null) {
    num = 0;
  }

  const si = [{ value: 1e6, symbol: 'M' }, { value: 1e3, symbol: 'k' }];

  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;

  for (let i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (num / si[i].value).toFixed(digits).replace(rx, '$1') + si[i].symbol;
    }
  }

  return Number(num)
    .toFixed(digits)
    .replace(rx, '$1');
}

export function parseIntInput(val) {
  return val.length > 0 ? parseInt(val.replace(/,/g, ''), 10) : 0;
}

export function formatTimeFromNow(date, options) {
  if (typeof date === 'number' || typeof date === 'string') {
    date = new Date(date);
  } else if (date instanceof String) {
    date = new Date(date.toString());
  } else if (typeof date.getMonth !== 'function') {
    return '';
  }

  options = options || {};
  const now = options.now || new Date();
  const delta = Math.floor((now.getTime() - date.getTime()) / 1000);
  const locale = 'en-US';
  const timeFormat = { hour: 'numeric', minute: '2-digit' };
  const dateFormat = { month: 'long', day: 'numeric' };

  if (options.seconds && delta < 60) {
    return `${delta} second${delta > 1 ? 's' : ''} ago`;
  }

  if (delta < 60) {
    return `less than a minute ago`;
  }
  if (delta < 3600) {
    return `${Math.floor(delta / 60)} minute${delta > 120 ? 's' : ''} ago`;
  }

  if (options.dateOnly) {
    return `${date.toLocaleDateString(locale, { month: 'short', day: 'numeric' })}`;
  }

  // set to midnight
  now.setMilliseconds(0);
  now.setSeconds(0);
  now.setMinutes(0);
  now.setHours(0);

  if (date.getTime() >= now.getTime()) {
    return `${options.noPrefix ? '' : 'at '}${date.toLocaleTimeString(locale, timeFormat)}`;
  }

  // set to yesterday midnight
  now.setTime(now.getTime() - 86400000);

  if (date.getTime() >= now.getTime()) {
    return `yesterday at ${date.toLocaleTimeString(locale, timeFormat)}`;
  }

  return `${date.toLocaleDateString(locale, dateFormat)} at ${date.toLocaleTimeString(
    locale,
    timeFormat
  )}`;
}

export function formatDate(date) {
  const dateObj = new Date(date);
  const monthName = dateObj.toLocaleString('en-us', { month: 'long' });
  return `${monthName} ${dateObj.getDate()}, ${dateObj.getFullYear()}`;
}
